// A summary of Parcels Packed
import React from "react";
import WhiteBox from "../../Styled/WhiteBox";

export default function ParcelsPacked() {
  return <WhiteBox>Parcels Packed</WhiteBox>;
}
